export default {
  creditCard: {
    backToDashboard: 'general.backToDashboard',
    title: 'creditCard.title',
    delete: 'creditCard.delete',
  },
};
